<template>
  <div>
    <div class="fc jc ac">
      <div class="blob" style="margin-top:100px">{{param.name}}</div>
      <div class="mt30 blob" v-if="param.company_name">{{param.company_name}}</div>
      <div class="mt30 blob" v-if="!param.company_name">{{param.username}}</div>
      <div class="mt30 blob">{{param.money}}元</div>
    </div>

    <div class="fr jc ac mt30">
      <van-button type="danger" size="small" @click="submit">确认</van-button>
      <van-button class="ml30" type="danger" size="small" @click="back">返回</van-button>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      uuid: "",
      param: {}
    };
  },
  mounted() {
    let param = JSON.parse(this.$route.query.param);
    this.param = param;
  },
  methods: {
    payMent() {
      if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.onBridgeReady,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
          document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
        }
      } else {
        this.onBridgeReady();
      }
    },
    onBridgeReady() {
      let that = this;

      let param = {
        openid: this.param.openid,
        total_fee: this.param.money,
        uuid: this.uuid
      };

      if (!param.openid) {
        Toast("openid为空");
        return;
      }

      if (!param.total_fee) {
        Toast("total_fee为空");
        return;
      }

      if (!param.uuid) {
        Toast("uuid为空");
        return;
      }

      Toast.loading();
      this.post("wx/wxpay", param).then(res => {
        WeixinJSBridge.invoke("getBrandWCPayRequest", res.data, function(res) {
          // 支付结果
          alert(JSON.stringify(res));
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            alert("支付成功");
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
            Toast.clear();
            try {
              that.$router.push({
                path: "/contributeMoney/cert",
                query: {
                  cert_img: param.uuid,
                  money: param.total_fee
                }
              });
            } catch (e) {
              alert(e);
            }
          }
        });
      });
    },
    back() {
      this.$router.push({
        path: "/contributeMoney/home",
        query: {
          param: JSON.stringify(this.param)
        }
      });
    },
    submit() {
      let param = this.param;

      if (!param.name) {
        Toast("选择捐款意向");
        return;
      }

      if (param.jkfs_index === "") {
        Toast("选择捐款方式");
        return;
      }

      if (param.is_real_name === "") {
        Toast("选择是否实名公开");
        return;
      }
      if (param.is_receipt === "") {
        Toast("选择是否需要收据");
        return;
      }

      if (param.money < 0.01) {
        Toast("捐款金额需大于0.01元");
        return;
      }
      if (!param.openid) {
        Toast("openid为空,请退出重新进入");
        return;
      }

    Toast.loading();
      this.post("contributeMoney/add", this.param).then(res => {
        this.uuid = res.data;

        this.payMent();
      });
    }
  }
};
</script>
<style lang="less" scoped>
</style>